import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hasErrorOccured: false,
  message: '',
};

export const handleAPIStatusSlice = createSlice({
  name: 'errorNotification',
  initialState,
  reducers: {
    errorNotification: (state = {}, action) => {
      return { ...state, ...action.payload };
    },
    clearNotification: () => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { errorNotification, clearNotification } =
  handleAPIStatusSlice.actions;

export default handleAPIStatusSlice.reducer;
